/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import { type CSSProperties, type JSX } from 'react';
import { type RequiredTestId } from '@common/components/controls/TestId';
import Icon, { type IconComponentType } from '@common/components/Icon';
import { useCloseMenu } from '@common/components/Menu/MenuContextProvider';
import Translated from '@common/components/Translated';
import '@common/styles/components/menu.pcss';

interface MenuActionProps {
  id: string;
  onClick: () => void;
  tagName?: keyof JSX.IntrinsicElements;
  style?: CSSProperties;
  leadingIcon?: IconComponentType;
}

function MenuActionOption({
  id,
  onClick,
  tagName = 'span',
  style,
  leadingIcon,
  ...rest
}: RequiredTestId<MenuActionProps>) {
  const closeMenu = useCloseMenu();

  return (
    <div
      role="menuitem"
      tabIndex={0}
      className="menu__option menu__option--action"
      style={style}
      onClick={() => closeMenu(onClick)}
      onKeyDown={(event) => {
        if (event.code === 'Enter') {
          event.preventDefault();
          closeMenu(onClick);
        }
      }}
      {...rest}
    >
      <div className="menu__option-content">
        {leadingIcon && (
          <span className="menu__option-leading-icon">
            <Icon component={leadingIcon} />
          </span>
        )}
        <Translated className="menu__option-text" id={id} tagName={tagName} />
      </div>
    </div>
  );
}

export default MenuActionOption;
